var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".support-icon-white{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "support-icon-white",
    d: "M50,33.84A16.22,16.22,0,0,0,41.11,19.4,22.05,22.05,0,0,1,19.4,41.11,16.22,16.22,0,0,0,33.84,50a16,16,0,0,0,8.22-2.25l7.87,2.18-2.18-7.87A16,16,0,0,0,50,33.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "support-icon-white",
    d: "M38.18,19.09A19.09,19.09,0,1,0,2.65,28.8L.07,38.11l9.32-2.57A19.1,19.1,0,0,0,38.18,19.09Zm-22-4.44H13.23A5.86,5.86,0,1,1,23.05,19l-2.49,2.28v2.29H17.63V20l3.44-3.15a2.93,2.93,0,1,0-4.91-2.16Zm1.47,11.81h2.93v2.93H17.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportWhite);
export default __webpack_public_path__ + "static/media/support-white.48638d34.svg";
export { ForwardRef as ReactComponent };